module.exports = __webpack_public_path__ + "static/media/clearmin.2a68c18a.webp";